<template>
  <div class="container container-footer home bg-gray">
    <div class="home-header-fixed">
    <section class="search-header bg-white" ref="searchNav">
      <div class="search-input-row" @click="turnToSearch">
        <van-search class="disbledSearch" placeholder="搜索岗位名、岗位ID、门店名" disabled background="#fff" />
      </div>
    </section>

    <section class="address-bar" @click="mapSearch">
      <div class="address-bar-inner flex">
        <img class="address-icon lb-vm" src="../../assets/images/post/address.png" />
        <div class="address-text flex-1">
          <p class="address-label">当前位置</p>
          <p class="address-desc">{{ showMapAddress }}</p>
        </div>
        <i class="icon icon-chacha c-white" v-if="mapAddress" @click.stop="clearMapSearch"></i>
        <img class="address-arrow lb-vm" src="../../assets/images/post/right_arrow.png" />
      </div>
    </section>

    <section ref="homeFixedTop" class="home-filter" id="mydiv">
      <!-- <van-tabs @click="tabChange" v-if="showHollow"> //原业务逻辑-->
      <div class="home-filter-inner">
        <van-tabs @click="tabChange">
          <van-tab title="兼职">
            <home-filter @onFilterStation="filterStations" @onFilterWorkTimes="filterWorkTimes"
              @onFilterInterviewTimes="filterInterviewTimes" @onFilter="filter" @onFilterSex="filterSex"
              @onFilterCommission="filterCommission"
              :pickStatus="pickStatus" :checkTipPosition="checkTipPosition" :checkTipSex="checkTipSex"
              :checkWorkTime="checkWorkTime" :checkCommission="checkCommission"
              :checkInterviewTime="checkInterviewTime"></home-filter>
          </van-tab>
          <van-tab title="全职">
            <home-filter @onFilterStation="filterStations" @onFilterWorkTimes="filterWorkTimes"
              @onFilterInterviewTimes="filterInterviewTimes" @onFilter="filter" @onFilterSex="filterSex"
              @onFilterCommission="filterCommission"
              :pickStatus="pickStatus" :checkTipPosition="checkTipPosition" :checkTipSex="checkTipSex"
              :checkWorkTime="checkWorkTime" :checkCommission="checkCommission"
              :checkInterviewTime="checkInterviewTime"></home-filter>
          </van-tab>
        </van-tabs>
      </div>
    </section>
    </div>

    <van-swipe :autoplay="3000" indicator-color="white" class="banner-swip" v-if="swiperList.length">
      <van-swipe-item class="f0" v-for="(item, index) in swiperList" :key="index">
        <a :href="item.href">
          <img class="needsclick" :src="item.imgUrl" alt />
        </a>
      </van-swipe-item>
    </van-swipe>
    <!-- <van-swipe :autoplay="3000" indicator-color="white" class="banner-swip">
      <van-swipe-item class="f0">
        <img class="needsclick" src="../../assets/images/common/home.png" alt />
      </van-swipe-item>
      <van-swipe-item class="f0">
        <img class="needsclick" src="../../assets/images/common/home.png" alt />
      </van-swipe-item>
    </van-swipe> -->

    <section ref="listBox">
      <van-pull-refresh v-model="refreshing" @refresh="getList(true, true)"
        :class="swiperList.length ? 'van-pull' : 'van-pull-active'">
        <van-list class="mb10" v-model="loading" :finished="finished" :immediate-check="false" @load="getList()">
          <recruit-item v-for="(item, index) in list" :key="index" :item="item" :pickStatus="pickStatus"
            :mapAddress="mapAddress" :showDistance="true" :rowIndex="index" @confirm="onConfirm"></recruit-item>
        </van-list>
        <blank-tip tip="抱歉，暂无职位哦~" v-if="!loading && empty === 10"></blank-tip>
      </van-pull-refresh>
    </section>
    <!--  生成海报  -->
    <div id="share" style="position: fixed; right: -9999px; width: 100%; top: 0">
      <div class="poster-title" style="border-radius: 0">
        <img src="../../assets/images/poster/t-logo.png" class="poster-logo lb-vm" />
      </div>
      <info :recruit="recruitItem" :showShare="true">
        <template #shareImg>
          <div class="txt-r">
            <img :src="codeData" @load="initCanvas" @error="initCanvas" class="qr pr25 pb10" />
          </div>
        </template>
      </info>
    </div>
    <!--  生成海报  -->
    <div id="sharesmall" style="position: fixed; right: -7777px; width: 100%; top: 0">
      <div class="poster-title" style="border-radius: 0">
        <img src="../../assets/images/poster/t-logo.png" class="poster-logo lb-vm" />
      </div>
      <infosmall :recruit="recruitItem" :showShare="true">
        <template #shareSmallImg>
          <div class="txt-r">
            <img :src="codeData2" @load="initCanvas2" @error="initCanvas2" class="qr pr25 pb10" />
          </div>
        </template>
      </infosmall>
    </div>

    <filter-popup ref="filterPopup" @search="search" @callPositionPopup="callPositionPopup"></filter-popup>
    <filter-position-type-popup ref="filterPositionTypePopup" @search="search"></filter-position-type-popup>
    <filter-position-class-popup ref="filterPositionClassPopup" :enterType="1"
      @search="search"></filter-position-class-popup>
    <filter-interview-times-popup ref="filterInterviewTimesPopup" @search="search"></filter-interview-times-popup>
    <filter-sex-popup ref="filterSexPopup" @search="search"></filter-sex-popup>
    <filter-commission-popup ref="filterCommissionPopup" @search="search"></filter-commission-popup>
    <tab-bar></tab-bar>
    <scroll-top v-show="showTop"></scroll-top>
    <van-dialog v-model="show" title="分享到" show-cancel-button :showConfirmButton="false">
      <van-row type="flex" justify="center" class="mt19 mb20">
        <van-col span="9" class="txt-c" @click.native="doShare(1, `${shareId}`)">
          <p>
            <img class="poster-img" src="../../assets/images/poster/wx.png" />
          </p>
          <p class="pt8 f12 pb10">微信</p>
        </van-col>
        <van-col span="9" class="txt-c" @click.native="doShare(2, `${shareId}`)">
          <p>
            <img class="poster-img" src="../../assets/images/poster/pyq.png" />
          </p>
          <p class="pt8 f12 pb10">朋友圈</p>
        </van-col>
      </van-row>
    </van-dialog>
  </div>
</template>

<script>
import info from "../recruit/info";
import infosmall from "../recruit/infosmall";
import api from "../../api";
import html2canvas from "html2canvas";
import tabBar from "../../components/tab-bar";
import scrollTop from "../../components/scroll-top";
import blankTip from "../../components/blank-tip";
import recruitItem from "../../components/recruit-item";
import homeFilter from "../../components/home-filter";
import advert from "../../mixins/advert";
import recruit from "../../mixins/recruit";
import filterPopup from "./filter-popup";
import filterPositionTypePopup from "./filter-positiontype-popup";
import filterPositionClassPopup from "./filter-positionclass-popup";
import filterInterviewTimesPopup from "./filter-interviewtimes-popup";
import filterSexPopup from "./filter-sex-popup";
import filterCommissionPopup from "./filter-commission-popup";
import {
  showChooseMap,
  shareWithApp,
  getAppInfo,
  getLocation,
  launchMiniProgram,
} from "../../libs/native-app";
import { convertBase64ToBlob, checkDevice } from "../../libs/util";

const {
  areaList,
  WorkTimeType,
  ExperienceAge,
  PositionTypes,
} = require("../../libs/config");

export default {
  name: "home",
  components: {
    tabBar,
    scrollTop,
    blankTip,
    recruitItem,
    filterPopup,
    homeFilter,
    filterPositionTypePopup,
    filterPositionClassPopup,
    filterInterviewTimesPopup,
    filterSexPopup,
    filterCommissionPopup,
    info,
    infosmall,
  },
  mixins: [advert, recruit],
  data() {
    return {
      show: false,
      areaList: areaList,
      workTimes: WorkTimeType,
      experiences: ExperienceAge,
      checkTipPosition: "岗位",
      checkTipSex: "性别",
      checkWorkTime: "班次",
      checkCommission: "佣金",
      checkInterviewTime: "面试时间",
      positionTypes: PositionTypes,
      activeNames: ["0", "1", "2", "3", "4"],
      empty: 0,
      list: [],
      refreshing: false,
      loading: false,
      finished: false,
      Paging: { PageIndex: 1, PageSize: 10 },
      pickStatus: 0,
      cateList: [],
      mapAddress: null,
      sourceQuery: {
        ageLower: 0,
        ageUpper: 0,
        genderRequire: 0,
        hasCommission: null,
        interviewTime: [],
        positionIds: [],
        shiftType: [],
        welfareTagId: [],
        experienceRequire: [],
      },
      query: {
        ageLower: 0,
        ageUpper: 0,
        genderRequire: 0,
        hasCommission: null,
        interviewTime: [],
        positionIds: [],
        shiftType: [],
        welfareTagId: [],
        experienceRequire: [],
      },
      appVer: "",
      locationQuery: null,
      deviceLocation: null,
      showTop: false,
      showMapAddress: "输入地址快速搜工作",
      recruitItem: { SalaryMin: 0, SalaryMax: 0, PositionUrlList: [] },
      shareType: 0,
      shareId: null,
      codeData: null,
      codeData2: null,
      canvasData: "",
      lastScrollLength: 0,
      userName: "",
      mType: 0,
      isRequesting: false, // 防止重复请求
    };
  },
  computed: {
    swiperList() {
      return this.bannerList;
    },
  },
  activated() {
    if (this.$store.state.recruit) {
      var findVal = this.list.find((item) => {
        return item.id * 1 === this.$store.state.recruit.id * 1;
      });
      if (findVal) {
        findVal.leftCount = this.$store.state.recruit.leftCount;
        findVal.applyCount = this.$store.state.recruit.applyCount;
        findVal.button = this.$store.state.recruit.button;
        findVal.isLeaderPick = this.$store.state.recruit.isLeaderPick;
      }
      this.$store.commit("updateRecruit", null);
    }
  },
  deactivated() { },
  async mounted() {
    console.log(this.$route);
    if (this.$route.query.position) {
      this.mapSearch(JSON.parse(this.$route.query.position));
    }

    // 获取轮播图，失败不影响其他功能
    try {
      await this.getBannerList();
    } catch (e) {
      console.error("获取轮播图失败:", e);
    }
    // 确保拿到当前定位后再请求列表
    await this.ensureLocation();
    // 获取招聘列表
    try {
      await this.getList(true);
    } catch (e) {
      console.error("获取招聘列表失败:", e);
    }
    // 获取分类
    try {
      await this.getCommonCategorys();
    } catch (e) {
      console.error("获取分类失败:", e);
    }
    try {
      const ver = await getAppInfo();
      this.appVer = ver.version;
    } catch (e) { }
    window.addEventListener("scroll", this.onScroll);
  },
  methods: {
    validLocation(pos) {
      return !!(
        pos &&
        pos.lat !== null && pos.lat !== undefined && pos.lat !== "" &&
        pos.lng !== null && pos.lng !== undefined && pos.lng !== "" &&
        Number(pos.lat) !== 0 &&
        Number(pos.lng) !== 0
      );
    },
    getActiveLocation() {
      if (this.validLocation(this.locationQuery)) {
        return this.locationQuery;
      }
      if (this.validLocation(this.query)) {
        return { lat: this.query.lat, lng: this.query.lng };
      }
      if (this.validLocation(this.deviceLocation)) {
        return this.deviceLocation;
      }
      return null;
    },
    async ensureLocation() {
      if (this.validLocation(this.$store.state.pos)) {
        this.deviceLocation = this.$store.state.pos;
        return;
      }
      try {
        // 兜底 3 秒，避免原生定位无回调时阻塞列表加载
        const res = await Promise.race([
          getLocation(),
          new Promise((resolve) => setTimeout(() => resolve(null), 3000)),
        ]);
        if (this.validLocation(res)) {
          this.deviceLocation = res;
          this.$store.commit("updatePos", res);
        }
      } catch (e) {
        console.warn("定位获取失败:", e);
      }
    },
    onScroll() {
      // console.log(this.$refs.contentRef.offsetTop);
      let bodyScrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (bodyScrollTop > this.$refs.listBox.offsetTop) {
        this.showBackTop = true;
        this.showTop = true;
      } else {
        this.showBackTop = false;
        this.showTop = false;
        // this.topNavShow = false;
      }
    },
    async getCommonCategorys() {
      try {
        // const result = await this.$store.dispatch('postData', {
        //   url: '/api/vpai/recruit/list_positions',
        //   data: { Extra: { ModuleSysNo: 1000, ModuleSourceType: 1006, CategoryTreeName: 'IndustryClass1006' } }
        // });
        const result = await api.get("/api/vpai/recruit/list_positions");
        const dataList = Array.isArray(result) ? result : result.data || [];
        this.cateList = dataList
          .filter((v) => v.hyName !== "不限")
          .map((item, index) => ({
            CategorySysNo: index + 1,
            CategoryName: item.hyName,
            Categorys: (item.positionTypes || []).map((pos) => ({
              CategorySysNo: pos.gwId,
              CategoryName: pos.gwName,
            })),
          }));
        this.$refs.filterPositionTypePopup.cateList = this.cateList;
        this.$refs.filterPopup.cateList = this.cateList;

        // 给 filterPositionClassPopup 传数据（格式为 industryList）
        const industryList = dataList.map((item, index) => ({
          id: index + 1,
          name: item.hyName,
          positions: (item.positionTypes || []).map((pos) => ({
            id: pos.gwId,
            name: pos.gwName,
          })),
        }));
        this.$refs.filterPositionClassPopup.industryList = industryList;
        if (this.$refs.filterPopup.$refs.filterPositionClassPopup) {
          this.$refs.filterPopup.$refs.filterPositionClassPopup.industryList =
            industryList;
        }
      } catch (e) {
        this.$toast(e.message);
      }
    },
    showCheckTipName() {
      if (this.query.UserGenderName) {
        this.checkTipSex = this.query.UserGenderName;
      } else {
        this.checkTipSex = "性别";
      }
      if (this.query.ShowTimeTip) {
        this.checkWorkTime = this.query.ShowTimeTip;
      } else {
        this.checkWorkTime = "班次";
      }
      if (this.query.hasCommission === true) {
        this.checkCommission = "有佣金";
      } else if (this.query.hasCommission === false) {
        this.checkCommission = "无佣金";
      } else {
        this.checkCommission = "佣金";
      }
      if (this.query.ShowInterviewTimeStr) {
        this.checkInterviewTime = this.query.ShowInterviewTimeStr;
      } else {
        this.checkInterviewTime = "面试时间";
      }
      if (this.query.PositionClassShowNameTips) {
        this.checkTipPosition = this.query.PositionClassShowNameTips;
      } else {
        this.checkTipPosition = "岗位";
      }
    },
    async getList(init = false, isRefresh = false) {
      try {
        // 防止重复请求（非 init 模式下，如果正在请求中则跳过）
        if (!init && this.isRequesting) {
          console.log('请求正在进行中，跳过本次请求');
          return;
        }
        this.isRequesting = true;

        if (init) {
          this.Paging.PageIndex = 1;
          window.scrollTo(0, 0);
        }
        if (isRefresh) this.refreshing = true;
        else this.loading = true;
        // 手动选择的地址优先，其次当前定位
        const loc = this.getActiveLocation();
        const hasLocation = this.validLocation(loc);
        // 有定位按距离（2），无定位按最新（3）
        const sort = hasLocation ? 2 : 3;
        this.showCheckTipName();
        // 构建接口参数
        const requestData = {
          ageLower: this.query.ageLower || null,
          ageUpper: this.query.ageUpper || null,
          genderRequire: this.query.genderRequire || 0,
          interviewTime: this.query.interviewTime || [],
          jobType: this.pickStatus === 0 ? 2 : 1,
          lat: hasLocation ? loc.lat : null,
          lng: hasLocation ? loc.lng : null,
          pageNum: this.Paging.PageIndex,
          pageSize: this.Paging.PageSize,
          positionIds: this.query.positionIds || [],
          shiftType: this.query.shiftType || [],
          sort: sort,
          welfareTagId: this.query.welfareTagId || [],
          workTimeType: null,
          experienceRequireList: this.query.experienceRequire || [],
        };
        // 佣金筛选：null 表示全部，不传该字段
        if (this.query.hasCommission !== null && this.query.hasCommission !== undefined) {
          requestData.hasCommission = this.query.hasCommission;
        }
        const result = await this.$store.dispatch("postData", {
          url: "/api/vpai/recruit/list_recruit",
          data: requestData,
          need_sign: false,
        });
        // 直接使用接口返回的数据
        let incomingList = Array.isArray(result) ? result : [];
        if (init) {
          this.list = incomingList;
        } else {
          // 去重追加，避免重复数据
          const existingIds = new Set(this.list.map(item => item.id));
          const newItems = incomingList.filter(item => !existingIds.has(item.id));
          this.list = [...this.list, ...newItems];
        }

        this.$nextTick(() => {
          const currentBatch = incomingList.length;
          const totalCount = this.list.length;
          this.empty = init && totalCount === 0 ? 10 : 0;
          // 若返回条数小于分页大小，视为已加载到底
          this.finished = currentBatch < this.Paging.PageSize;
          this.Paging.PageIndex++;
          this.loading = false;
          this.refreshing = false;
          this.isRequesting = false;
        });
      } catch (e) {
        this.loading = false;
        this.refreshing = false;
        this.finished = true;
        this.isRequesting = false;
        this.$error(e.message);
      }
    },
    tabChange(index) {
      if (this.pickStatus === index) return;
      this.pickStatus = index;
      this.list = [];
      // 使用深拷贝重置 query，避免数组引用问题
      this.query = JSON.parse(JSON.stringify(this.sourceQuery));
      if (!this.locationQuery) {
        this.showMapAddress = "输入地址快速搜工作";
      }
      this.checkTipPosition = "岗位";
      this.checkTipSex = "性别";
      this.checkWorkTime = "班次";
      this.checkCommission = "佣金";
      this.checkInterviewTime = "面试时间";
      this.$refs.filterPopup.clear();
      this.$refs.filterPositionClassPopup.clear();
      this.$refs.filterPositionTypePopup.clear();
      this.$refs.filterInterviewTimesPopup.clear();
      this.$refs.filterSexPopup.clear();
      this.$refs.filterCommissionPopup.clear();
      this.getList(true);
    },
    search(obj) {
      // 将旧字段格式转换为新接口格式
      const newQuery = {};

      // 转换年龄：AgeList -> ageLower, ageUpper
      if (obj.AgeList && obj.AgeList.length > 0) {
        // 取所有年龄范围的最小和最大值
        let minAge = 0;
        let maxAge = 0;
        obj.AgeList.forEach((item) => {
          const min = parseInt(item.AgeMin) || 0;
          const max = parseInt(item.AgeMax) || 0;
          if (minAge === 0 || min < minAge) minAge = min;
          if (max > maxAge) maxAge = max;
        });
        newQuery.ageLower = minAge;
        newQuery.ageUpper = maxAge;
      }

      // 转换性别：UserGenderList -> genderRequire
      if (obj.UserGenderList !== undefined) {
        if (
          obj.UserGenderList.length === 0 ||
          obj.UserGenderList.length === 2
        ) {
          newQuery.genderRequire = 0; // 不限
        } else if (obj.UserGenderList.length === 1) {
          newQuery.genderRequire = obj.UserGenderList[0]; // 1男 2女
        }
      }

      // 佣金筛选：null=全部 true=有佣金 false=无佣金
      if (obj.hasCommission !== undefined) {
        newQuery.hasCommission = obj.hasCommission;
      }

      // 转换面试时间：WeekDayList -> interviewTime
      if (obj.WeekDayList !== undefined) {
        newQuery.interviewTime = [...obj.WeekDayList];
      }

      // 转换岗位：PositionClassSysNoList -> positionIds
      if (obj.PositionClassSysNoList !== undefined) {
        newQuery.positionIds = [...obj.PositionClassSysNoList];
      }

      // 转换班次：WorkTimeTypeList/shiftType -> shiftType
      if (obj.shiftType !== undefined) {
        newQuery.shiftType = obj.shiftType.map(Number);
      } else if (obj.WorkTimeTypeList !== undefined) {
        newQuery.shiftType = obj.WorkTimeTypeList.map(Number);
      }

      // 转换福利待遇：PositionTagIdList -> welfareTagId
      if (
        obj.PositionTagIdList !== undefined &&
        obj.PositionTagIdList.length > 0
      ) {
        newQuery.welfareTagId = [...obj.PositionTagIdList];
      }

      // 转换经验要求：ExperienceList -> experienceRequire（数组形式支持多选）
      // config中的key: 0-不限, 1-1年以内, 2-1~3年, 3-3~5年, 4-5~10年, 5-10年以上
      // 接口需要的值: -1-不限, 0-1年以内, 1-1-3年, 3-3-5年, 5-5-10年, 10-10年以上
      if (obj.ExperienceList !== undefined && obj.ExperienceList.length > 0) {
        const experienceMap = {
          0: -1, // 不限
          1: 0, // 1年以内
          2: 1, // 1-3年
          3: 3, // 3-5年
          4: 5, // 5-10年
          5: 10, // 10年以上
        };
        // 转换为数组形式
        newQuery.experienceRequire = obj.ExperienceList.map(
          (key) => experienceMap[key]
        ).filter((v) => v !== undefined);
      } else if (
        obj.ExperienceList !== undefined &&
        obj.ExperienceList.length === 0
      ) {
        newQuery.experienceRequire = [];
      }

      // 转换经纬度（支持新旧两种字段名）
      if (obj.lat !== undefined) {
        newQuery.lat = obj.lat;
      } else if (obj.Latitude !== undefined) {
        newQuery.lat = obj.Latitude;
      }
      if (obj.lng !== undefined) {
        newQuery.lng = obj.lng;
      } else if (obj.Longitude !== undefined) {
        newQuery.lng = obj.Longitude;
      }

      // 保留显示用字段
      if (obj.UserGenderName !== undefined) {
        newQuery.UserGenderName = obj.UserGenderName;
      }
      if (obj.ShowInterviewTimeStr !== undefined) {
        newQuery.ShowInterviewTimeStr = obj.ShowInterviewTimeStr;
      }
      if (obj.ShowTimeTip !== undefined) {
        newQuery.ShowTimeTip = obj.ShowTimeTip;
      }
      if (obj.PositionClassShowNameTips !== undefined) {
        newQuery.PositionClassShowNameTips = obj.PositionClassShowNameTips;
      }

      this.query = { ...this.query, ...newQuery };

      // 同步班次数据：如果搜索对象包含班次数据，同步到两个弹窗
      if (obj.shiftType !== undefined) {
        // 从班次弹窗来的数据，同步到筛选弹窗
        this.$refs.filterPopup.workTimeTypeList = obj.shiftType.map(String);
      }
      if (obj.WorkTimeTypeList !== undefined) {
        // 从筛选弹窗来的数据，同步到班次弹窗
        this.$refs.filterPositionTypePopup.workTimeTypeList = [
          ...obj.WorkTimeTypeList,
        ];
      }
      // 同步岗位数据：不管从哪个岗位弹窗确认，都用obj的数据同步到两个弹窗
      if (
        obj.PositionClassSysNoList !== undefined &&
        obj.PositionClassShowList !== undefined
      ) {
        const popup1 = this.$refs.filterPositionClassPopup;
        const popup2 = this.$refs.filterPopup.$refs.filterPositionClassPopup;
        const filterPopup = this.$refs.filterPopup;
        const positionList =
          obj.PositionClassItemList ||
          obj.PositionClassSysNoList.map((id, idx) => ({
            id: id,
            name: obj.PositionClassShowList[idx] || "",
          }));
        // 同步到首页岗位弹窗
        popup1.selectPositionList = [...positionList];
        popup1.selectPositionIdList = [...obj.PositionClassSysNoList];
        popup1.selectPositionNameList = [...obj.PositionClassShowList];
        // 同步到筛选弹窗内的岗位弹窗
        popup2.selectPositionList = [...positionList];
        popup2.selectPositionIdList = [...obj.PositionClassSysNoList];
        popup2.selectPositionNameList = [...obj.PositionClassShowList];
        // 同步到筛选弹窗的岗位显示列表
        filterPopup.classNameList = [...obj.PositionClassShowList];
        filterPopup.positionClassNameList = [...obj.PositionClassShowList];
        filterPopup.positionClassSynNoList = [...obj.PositionClassSysNoList];
      }
      // 同步面试时间数据：不管从哪个弹窗确认，都同步到另一个
      // 用 UserGenderName 来区分：筛选弹窗会传这个字段，面试时间弹窗不会
      if (obj.WeekDayList !== undefined && obj.UserGenderName !== undefined) {
        // 从筛选弹窗来的数据，同步到面试时间弹窗
        this.$refs.filterInterviewTimesPopup.timeSysNoList = [
          ...this.$refs.filterPopup.timeSysNoList,
        ];
        this.$refs.filterInterviewTimesPopup.weekdayList = [
          ...this.$refs.filterPopup.weekdayList,
        ];
      } else if (obj.WeekDayList !== undefined) {
        // 从面试时间弹窗来的数据，同步到筛选弹窗
        this.$refs.filterPopup.timeSysNoList = [
          ...this.$refs.filterInterviewTimesPopup.timeSysNoList,
        ];
        this.$refs.filterPopup.weekdayList = [
          ...this.$refs.filterInterviewTimesPopup.weekdayList,
        ];
      }
      this.getList(true);
    },
    callPositionPopup(obj) {
      this.filterStations();
    },
    turnToSearch() {
      if (this.mapAddress) {
        if (this.mapAddress.name) {
          this.go(
            `search?area=${this.mapAddress.name}&lng=${this.mapAddress.lng}&lat=${this.mapAddress.lat}`
          );
        } else if (this.mapAddress.address) {
          this.go(
            `search?area=${this.mapAddress.address}&lng=${this.mapAddress.lng}&lat=${this.mapAddress.lat}`
          );
        } else {
          this.go(`search`);
        }
      } else {
        this.go(`search`);
      }
    },
    clearMapSearch() {
      let needFlash = false;
      if (this.locationQuery) {
        needFlash = true;
      }
      this.showMapAddress = "输入地址快速搜工作";
      this.locationQuery = null;
      this.mapAddress = null;
      if (needFlash) {
        // 清空手动地址，回退到当前定位
        this.query.lat = null;
        this.query.lng = null;
        this.search({});
      }
    },
    async mapSearch(lot) {
      let json = {
        lat: 0,
        lng: 0,
      };
      try {
        let res;
        if (lot && lot.latitude && lot.longitude) {
          res = { ...lot, lat: lot.latitude, lng: lot.longitude };
        } else {
          res = await showChooseMap(json);
        }

        this.mapAddress = res;
        if (this.mapAddress.name) {
          if (this.mapAddress.name.length > 9) {
            this.showMapAddress = this.mapAddress.name.substring(0, 9) + "...";
          } else {
            this.showMapAddress = this.mapAddress.name;
          }
        } else if (this.mapAddress.address) {
          if (this.mapAddress.address.length > 9) {
            this.showMapAddress =
              this.mapAddress.address.substring(0, 9) + "...";
          } else {
            this.showMapAddress = this.mapAddress.address;
          }
        }
        this.locationQuery = {
          lat: res.lat,
          lng: res.lng,
        };
        this.search(this.locationQuery);
      } catch (e) {
        if (e.message && e.message.indexOf("请先升级当前应用版本") >= 0) {
          if (checkDevice().isAndroid) {
            if (
              this.appVer.indexOf("1.0.0") > 0 ||
              this.appVer.indexOf("1.0.1") > 0 ||
              this.appVer.indexOf("1.0.2") > 0
            ) {
              this.$error(e.message);
            } else {
              this.turnToDownload();
            }
          } else {
            this.$error(e.message);
            this.turnToDownload();
          }
        }
      }
    },
    filterStations() {
      // 打开岗位弹窗前，从筛选弹窗内的岗位弹窗同步数据
      const popup1 = this.$refs.filterPositionClassPopup;
      const popup2 = this.$refs.filterPopup.$refs.filterPositionClassPopup;
      popup1.selectPositionList = [...popup2.selectPositionList];
      popup1.selectPositionIdList = [...popup2.selectPositionIdList];
      popup1.selectPositionNameList = [...popup2.selectPositionNameList];
      this.$refs.filterPositionClassPopup.show = true;
    },
    filterWorkTimes() {
      // 打开班次弹窗前，从筛选弹窗同步班次数据
      this.$refs.filterPositionTypePopup.workTimeTypeList = [
        ...this.$refs.filterPopup.workTimeTypeList,
      ];
      this.$refs.filterPositionTypePopup.show = true;
    },
    filterInterviewTimes() {
      // 打开面试时间弹窗前，从筛选弹窗同步数据
      this.$refs.filterInterviewTimesPopup.timeSysNoList = [
        ...this.$refs.filterPopup.timeSysNoList,
      ];
      this.$refs.filterInterviewTimesPopup.weekdayList = [
        ...this.$refs.filterPopup.weekdayList,
      ];
      this.$refs.filterInterviewTimesPopup.show = true;
    },
    filterSex() {
      this.$refs.filterSexPopup.show = true;
    },
    filterCommission() {
      // 打开前同步当前筛选状态
      if (this.query.hasCommission === true) {
        this.$refs.filterCommissionPopup.commissionType = 1;
      } else if (this.query.hasCommission === false) {
        this.$refs.filterCommissionPopup.commissionType = 2;
      } else {
        this.$refs.filterCommissionPopup.commissionType = 0;
      }
      this.$refs.filterCommissionPopup.show = true;
    },
    filter() {
      // 打开筛选弹窗前，从班次弹窗同步班次数据
      this.$refs.filterPopup.workTimeTypeList = [
        ...this.$refs.filterPositionTypePopup.workTimeTypeList,
      ];
      // 打开筛选弹窗前，从面试时间弹窗同步数据
      this.$refs.filterPopup.timeSysNoList = [
        ...this.$refs.filterInterviewTimesPopup.timeSysNoList,
      ];
      this.$refs.filterPopup.weekdayList = [
        ...this.$refs.filterInterviewTimesPopup.weekdayList,
      ];
      // 打开筛选弹窗前，从首页岗位弹窗同步到筛选弹窗内的岗位弹窗
      const popup1 = this.$refs.filterPositionClassPopup;
      const popup2 = this.$refs.filterPopup.$refs.filterPositionClassPopup;
      popup2.selectPositionList = [...popup1.selectPositionList];
      popup2.selectPositionIdList = [...popup1.selectPositionIdList];
      popup2.selectPositionNameList = [...popup1.selectPositionNameList];
      this.$refs.filterPopup.show = true;
      this.$refs.filterPopup.pickStatus = this.pickStatus;
    },
    async getRecruitBySysNo(id) {
      try {
        var findVal = this.list.find((item) => {
          return item.id * 1 === id * 1;
        });
        this.recruitItem = findVal;
        this.getCodeData();
      } catch (e) {
        this.$error(e.message);
      }
    },
    async getCodeData() {
      try {
        this.$loading("获取数据");
        this.codeData2 = null;
        this.codeData = null;
        const result = await this.$store.dispatch("postData", {
          url: "/liteapp/get-wx-acode-unlimit",
          data: {
            RecruitSysNo: this.recruitItem.id,
            PersonSysNo: this.$store.state.person.PersonSysNo,
          },
        });
        if (this.shareType === 1) {
          this.codeData2 = result;
          console.log(JSON.stringify(this.codeData2));
        } else {
          this.codeData = result;
          console.log(JSON.stringify(this.codeData));
        }
      } catch (e) {
        this.$error(e.message);
      }
    },
    async initCanvas() {
      if (!this.recruitItem.id) {
        this.$loadingClose();
      }
    },
    async initCanvasDraw() {
      setTimeout(() => {
        this.initCanvasDrawDo();
      }, 1000);
    },
    async initCanvasDrawDo() {
      this.$loading("绘制中");
      if (this.shareType === 1) {
        let canvas = await html2canvas(document.getElementById("sharesmall"), {
          scale: 2,
        });
        this.canvasData = canvas.toDataURL("image/jpeg");
      } else {
        let canvas = await html2canvas(document.getElementById("share"), {
          scale: 2,
        });
        this.canvasData = canvas.toDataURL("image/jpeg");
      }
      console.log(this.canvasData);
      console.log("this.canvasData1");
      window.scrollTo(0, this.lastScrollLength);
      this.lastScrollLength = 0;
      this.$loadingClose();
      if (this.shareType > 0) {
        this.share(this.shareType);
      }
    },
    async initCanvas2() {
      // 此处需要小程序二维码加载完成后执行
      if (!this.recruitItem.id) {
        this.$loadingClose();
        return;
      }
      // 不能移除下句代码，用于防止滚动条对截图造成的空白影响
      this.lastScrollLength =
        document.documentElement.scrollTop || document.body.scrollTop;
      window.scrollTo(0, 0);
      this.initCanvas2Draw();
    },
    initCanvas2Draw() {
      setTimeout(() => {
        this.initCanvas2DrawDo();
      }, 1000);
    },
    async initCanvas2DrawDo() {
      this.$loading("绘制中");
      if (this.shareType === 1) {
        let canvas = await html2canvas(document.getElementById("sharesmall"), {
          scale: 2,
        });
        this.canvasData = canvas.toDataURL("image/jpeg");
      } else {
        let canvas = await html2canvas(document.getElementById("share"), {
          scale: 2,
        });
        this.canvasData = canvas.toDataURL("image/jpeg");
      }
      console.log(this.canvasData);
      console.log("this.canvasData2");
      window.scrollTo(0, this.lastScrollLength);
      this.lastScrollLength = 0;
      this.$loadingClose();
      if (this.shareType > 0) {
        this.share(this.shareType);
      }
    },
    onConfirm(id) {
      // 当前选择对象的id
      console.log(id);
      this.shareId = id;
      // 直接分享到微信，不再弹出选择框
      this.doShare(1, id);
    },
    async doShare(shareType, id) {
      try {
        this.$loading("准备分享...");
        this.shareType = shareType;

        // 从列表中找到当前招聘项
        const recruitItem = this.list.find((item) => {
          return item.id * 1 === id * 1;
        });

        if (!recruitItem) {
          this.$loadingClose();
          this.$toast("未找到招聘信息");
          return;
        }

        // 1. 调用接口获取分享追踪令牌
        const tokenResult = await api.get("/api/share/create_share_token", {
          params: {
            recruitDispatchRecordId: recruitItem.recruitDispatchRecordId || "",
            recruitId: recruitItem.id || "",
          },
        });

        // 获取追踪Token
        let trackToken = "";
        if (tokenResult.code === 10000 && tokenResult.data) {
          trackToken = tokenResult.data;
        }
        console.log("分享追踪Token:", trackToken);

        // 检查环境
        const ua = navigator.userAgent;
        const isWxmp = ua.toLowerCase().indexOf('miniprogram') > -1;

        if (shareType === 1) {
          // 微信好友分享
          if (isWxmp) {
            // 小程序环境：跳转到小程序分享页面
            launchMiniProgram({
              appId: "wxbb140f2dced7d207",
              path: `subPackages/aboutPost/pages/post_detail/share?id=${id}&shareToken=${trackToken}&shareFlag=true`,
              envVersion: "trial",//release
            });
            this.$loadingClose();
            this.show = false;
            return;
          } else {
            // APP环境：分享小程序卡片
            const miniPath = `subPackages/aboutPost/pages/post_detail/share?id=${id}&shareToken=${trackToken}&IsFromShare=1`;
            const shareObj = {
              shareMedia: 3, // 3-小程序卡片
              shareType: 1, // 1-微信好友
              title: `就业队长招聘${recruitItem.title || ""}`,
              imgUrl: recruitItem.imgUrls && recruitItem.imgUrls[0] ? recruitItem.imgUrls[0] : "",
              imageUrl: recruitItem.imgUrls && recruitItem.imgUrls[0] ? recruitItem.imgUrls[0] : "",
              userName: "gh_49bd5402050d",
              path: miniPath,
              mType: 0, // 0-正式版
            };
            await shareWithApp(shareObj);
            this.$loadingClose();
            this.show = false;
            return;
          }
        } else if (shareType === 2) {
          // 朋友圈分享 - 使用海报分享流程
          // this.recruitItem = recruitItem;
          // this.getCodeData();
        }
      } catch (e) {
        this.$loadingClose();
        this.show = false;
        console.error("分享失败:", e);
        this.$toast(e.message || "分享失败");
      }
    },
    // 以下是旧的分享流程方法，暂时保留但不使用
    async doShareOld(shareType, id) {
      this.$loading();
      this.shareType = shareType;
      this.getRecruitBySysNo(id);
    },
    async share(index) {
      try {
        if (!this.recruitItem.id) {
          return;
        }
        this.$loading("分享中");
        this.$loading("请稍后", 3000);
        await this.$store.dispatch("postData", {
          url: "/recruit/LeaderPickRecruit",
          data: {
            Body: {
              RecruitSysNo: this.recruitItem.id,
              PersonSysNo: this.$store.state.person.PersonSysNo,
            },
          },
        });
        var findVal = this.list.find((item) => {
          return item.id * 1 === this.recruitItem.id * 1;
        });
        if (findVal) {
          findVal.isLeaderPick = 1;
        }
        if (index === 1) {
          this.getShareData(this.recruitItem.id);
        } else {
          try {
            await shareWithApp({
              imgUrl: this.canvasData,
              shareType: index,
              shareMedia: 2,
            });
            this.$loadingClose();
          } catch (e) {
            this.show = false;
            this.$toast(e.message);
          }
        }
      } catch (e) {
        this.$toast(e.message);
      }
    },
    async getShareData(id) {
      try {
        // 获取分享参数
        if (!this.userName) {
          let res = await this.$store.dispatch("postData", {
            url: "/recruit/GetShareData",
            data: {},
          });
          console.log("getShareData:", res);
          this.userName = res.username;
          this.mType = parseInt(res.mtype);
          this.doShareLittleApp(id);
        } else {
          this.doShareLittleApp(id);
        }
      } catch (e) {
        this.$toast(e);
      }
    },
    async doShareLittleApp(id) {
      let file = convertBase64ToBlob(this.canvasData);
      let formData = new FormData();
      formData.append("folder", "authen");
      formData.append("file[]", file);
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      let ossRes = await api.post(`/upload/upload-images`, formData, config);
      console.log(ossRes.Data[0].url);
      if (ossRes && ossRes.Data && ossRes.Data.length > 0) {
        // 分享小程序卡片
        let path = "";
        path = `pages/post_detail/post_detail?RecruitSysNo=${id}&LeaderPersonSysNo=${this.$store.state.person.PersonSysNo}&FromPersonSysNo=${this.$store.state.person.PersonSysNo}&IsFromShare=1&t=2&t=2`;
        // if (this.$store.state.person.LeaderPersonSysNo) {
        // } else {
        //   path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&FromPersonSysNo=${this.$store.state.person.PersonSysNo}&IsFromShare=1&t=2`;
        // }
        let shareObj = {
          shareMedia: 3,
          shareType: 1,
          imgUrl: ossRes.Data[0].url,
          imageUrl: ossRes.Data[0].url,
          link: "http://www.baidu.com",
          title: `就业宝招聘${this.recruitItem.title}`,
          userName: this.userName,
          path: path,
          mType: this.mType,
        };
        try {
          await shareWithApp(shareObj);
          this.$loadingClose();
        } catch (e) {
          this.show = false;
          this.$toast(e.message);
        }
      } else {
        this.$loadingClose();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/theme.less";

.flex-15 {
  flex: 1.5;
}

.drawline {
  height: 1px;
  width: 100%;
}

.banner-swip {
  height: 100px;
  margin: 0 12px;
  border-radius: 14px;
  overflow: hidden;
}

.banner-swip img {
  height: 100px;
  width: 100%;
}

.banner-swip .van-swipe__indicators {
  left: auto;
  right: 20px;
  transform: translateX(0);
}

.home {
  padding-top: 230px;
}

.home-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  background: #f7faff;
}

.search-title-row {
  padding: 11px 16px;
}

.search-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.search-input-row {
  padding: 16px 12px 12px;
  font-size: 14px;
  color: #9CA3AF;
}

.address-bar {
  margin: 12px 12px 12px;
  background: #FB7613;
  border-radius: 15px;
}

.address-bar-inner {
  padding: 10px 16px;
  align-items: center;
}

.address-icon {
  width: 30px;
  height: 30px;
  margin-right: 11px;
}

.address-arrow {
  width: 18px;
  height: 18px;
}

.address-label {
  font-weight: 400;
  font-size: 12px;
  color: #FEE4D0;
}

.address-desc {
  font-size: 14px;
  color: #FFFFFF;
  margin-top: 2px;
}

.popup-del {
  padding: 10px 0 5px 15px;
}

.home-per {
  max-height: calc(100vh - 90px);
  overflow-y: auto;
}

.home-per .van-cell,
.home-per .van-collapse-item__content {
  background: @white;
  font-size: 12px;
}

.home-per .van-collapse-item__content {
  padding: 0 15px;
}

.ds-partime-list {
  padding-top: 1px;
}

.ds-partime-list>p {
  border-color: @borderColor;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  padding: 0 10px;
}

.ds-partime-list>p.selected {
  border-color: @primaryColor;
  background-size: 18px 14px;
}

.search-header {
  width: 100%;
  background: #fff;
}

.ds-list-divider {
  width: 50%;
  margin: 15px auto;
}

.fringe .van-cell__value--alone {
  color: #666;
}

// .van-hairline--top-bottom::after {border-width: 0;}
.home .van-search {
  padding: 10px 0;
}

.home .van-search.disbledSearch {
  pointer-events: none;
}

.search-input-row .van-search {
  padding: 0;
}

.search-input-row /deep/ .van-search__content {
  border-radius: 10px;
}

.search-input-row /deep/ .van-icon-search {
  color: #9CA3AF;
}

.home /deep/.van-field__control,
.home /deep/.van-field__control::-webkit-input-placeholder {
  font-size: 12px;
}

.home .ds-job-list-box {
  margin: 0px 12px 10px 12px;
}

.select-filter {
  margin: 12px 15px 0 0;
}

.select-div {
  width: 70%;
  // margin-left: 15px;
}

.select-box {
  box-sizing: border-box;
  background: #fff;
  height: 30px;
  border: 1px solid #E5E7EB;
  border-radius: 20px;
  width: 65px;
  padding: 6px 10px;
  position: relative;
  color: #1F2A37;
}

.select-box-l {
  width: 90px;
}

.select-box.van-hairline--surround::after {
  border-radius: 50px;
}

.select-box p {
  font-size: 12px;
  font-weight: 400;
  color: #1F2A37;
  line-height: 24px;
}

.home-filter-inner {
  padding: 0 12px;
}

.home {
  overflow: visible;
}

.poster-title {
  height: 41px;
  line-height: 41px;
  border-radius: 5px 5px 0 0;
  background: linear-gradient(146deg,
      rgba(255, 134, 58, 1) 0%,
      rgba(253, 100, 4, 1) 100%);
}

.poster-logo {
  height: 40px;
  width: auto;
  margin-left: 10px;
}

.ds-divider-title {
  position: relative;
  overflow: hidden;
}

.ds-divider-title::after {
  content: "";
  position: absolute;
  height: 1px;
  background: @borderColor;
  top: 50%;
  left: 0;
  width: 100%;
}

.ds-divider-title>h3,
.ds-divider-title>p {
  background: @white;
  z-index: 2;
  position: relative;
}

.qr {
  width: 110px;
  height: 110px;
}

.poster-img {
  width: 44px;
  height: 44px;
}

.ds-list-divider>span {
  background: @bgGray;
}

.home-filter /deep/ .van-tabs__wrap {
  background: #fff;
  border-radius: 16px;
  box-shadow: none;
}

.home-filter /deep/ .van-tabs__wrap::after {
  display: none;
}

.home-filter /deep/ .van-tabs__nav {
  background: #fff;
  border-radius: 15px;
  box-shadow: none;
}

.home-filter /deep/ .van-tabs__nav::after {
  display: none;
}

.home-filter /deep/ .van-tab {
  flex: 1;
  height: 37px;
  margin: 3px;
  color: #8E8E9A;
  font-weight: 400;
  font-size: 14px;
  line-height: 37px;
}

.home-filter /deep/ .van-tab--active {
  background:#FB7613;
  border-radius: 12px;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 14px;
  line-height: 37px;
}

.home-filter /deep/ .van-tabs__line {
  display: none;
}
</style>
